module.exports = __webpack_public_path__ + "static/gfs-logo-5cee5f64c1411c53e2be664f49b771ea.png";